import React, {
  createContext,
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import RadarChart from "../../components/RadarChart/RadarChart";
import {DashboardContainer, TopBarContainer} from "./Dashboard.styles";
import Sidebar, {SidebarTab} from "../../components/Sidebar";
// import ClusterFilter from "../../components/ClusterFilter";
import SidebarCard from "../../components/SidebarCard";
import {DataIds, ITypeRadar} from "../../types";
import TechnologiesMap from "../../components/TechnologiesMap";
import {getFilteredData} from "../../hooks/getFilteredData";
import {initialStateFilters} from "./Dashboard.const";
import {IClustersMolecule, IinitialStateServerMap} from "./Dashboard.type";
import SearchMoleculesTopBar from "../../components/SearchTopBar";
import SidebarInfo from "../../components/SidebarInfo";
import {useParams} from "react-router-dom";
import {SidebarCardContainer} from "../../ui/SidebarCardContainer";
import {TitleMoleculeBarTopFind} from "./SearchMoleculeBartop";
import {apiKeyDataTehnology, urlApiDataTehnology} from "../../helper/api";
import useFetchDataTehnologies from "../../hooks/useFetchDataTehnologies";
import {AboutRadarTop} from "../../components/AboutRadarTop/AboutRadarTop";
import {Spinner} from "react-bootstrap";
import FullScreenSpinner from "../../ui/FullScreenSpinner";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../config/featureFlags";

export const DataIdsContext = createContext<any>(null);

interface Iprops {
  isMoleculeUrl?: boolean;
}

const Dashboard: React.FC<Iprops> = ({isMoleculeUrl = false}) => {
  const [typeRadar, setTypeRadar] = useState<ITypeRadar>("map");
  const [isShowAllLabels, setIsShowAllLabels] = useState(false);

  const [isNationalProjects, setIsNationalProjects] = useState(true);

  const apiUrlClusters = `${urlApiDataTehnology}/api/clusters`;
  const apiUrlDirections = `${urlApiDataTehnology}/api/directions`;
  const apiUrlMolecules = `${urlApiDataTehnology}/api/molecules`;
  const apiUrlMolecules2 = `${urlApiDataTehnology}/api/molecules2`;

  const [isVisibleFiltersPanel, setIsVisibleFiltersPanel] = useState(false);
  const [isOpenSearchPanel, setIsOpenSearchPanel] = useState(false);

  const [dataServer, setDataServer] = useState<IinitialStateServerMap>({
    directions: [],
    clusters: [],
  });
  const [searchDatasidebarInfo, setSearchDatasidebarInfo] =
    useState<IinitialStateServerMap>({} as IinitialStateServerMap);

  if (!apiKeyDataTehnology) {
    throw new Error("API key не тот");
  }

  const {
    clustersData,
    directionsData,
    moleculesData,
    moleculesData2,
    isLoading,
  } = useFetchDataTehnologies(
    apiUrlClusters,
    apiUrlDirections,
    apiUrlMolecules,
    apiUrlMolecules2,
    apiKeyDataTehnology
  );
  useEffect(() => {
    const fetchDataServer = {
      directions:
        typeRadar === "moleculeTwo"
          ? (moleculesData2?.data ?? []).map((item) => ({
              id: item.id,
              name: item.productName,
            }))
          : (directionsData?.data ?? []).map((item) => ({
              id: item.documentId,
              name: item.name,
              nptl: item.nptl,
            })),
      clusters:
        (clustersData?.data ?? [])
          .filter(
            (item) => item.direction && item.direction.documentId !== null
          )
          .map((item) => ({
            id: item.documentId,
            idNumber: item.id,
            name: item.name,
            image: item.image ?? "",
            market_volume_tier: item.market_volume_tier,
            invest_volume_tier: item.invest_volume_tier,
            growth_potential: item.growth_potential,
            critical: item.critical,
            national: item.national,
            gpb: item.gpb,
            direction_id: item.direction.documentId,
            maturity:
              item.maturity === "Высокая"
                ? "Продукт"
                : item.maturity === "Средняя"
                ? "Прототип"
                : "Концепт",
            size: 0.1,
            battery_russia: FEATURE_CLUSTER_BATTERY_METRIC_ENABLED
              ? item.battery_russia
              : "",
            battery_world: FEATURE_CLUSTER_BATTERY_METRIC_ENABLED
              ? item.battery_world
              : "",
          })) ?? [],
      technologies: [],
    };

    setDataServer(fetchDataServer);
    setSearchDatasidebarInfo(fetchDataServer);
  }, [directionsData, clustersData, typeRadar, moleculesData2]);

  const [moleculeVActive, setMoleculeVActive] = useState(1);
  const {moleculeName} = useParams();
  const [activeSidebarTab, setActiveSidebarTab] = useState<SidebarTab>(
    SidebarTab.Empty
  );
  const [idRndIndex, setIdRndIndex] = useState(0);
  const [isMoleculaRadarActive, setIsMoleculaRadarActive] =
    useState(isMoleculeUrl);
  const [idMoleculeActive, setIdMoleculeActiv] = useState<
    number | string | null
  >(null);
  const [radarDataMolecula, setRadarDataMolecula] = useState(
    {} as IClustersMolecule
  );
  const [isOpenPanel, setIsOpenPanel] = useState(false);
  const [isOpenSideBar, setIsOpenSideBar] = useState<boolean>(false);
  const [isOpenSideBarInfo, setIsOpenSideBarInfo] = useState<boolean>(false);

  const [isSearchPanelActive, setIsSearchPanelActive] = useState(false);
  const [filters, setFilters] = useState(initialStateFilters);
  const [cpuStep, setCpuStep] = useState(1);
  const [activeTab, setActiveTab] = useState(SidebarTab.Empty);
  const [activeClusterId, setActiveClusterId] = useState<
    number | string | null | undefined
  >();
  const [activeTehnologyId, setActiveTehnologyId] = useState<
    number | string | null | undefined
  >();
  const [activeDirectionId, setActiveDirectionId] = useState<
    number | string | null | undefined
  >();
  const [moleculaActiveTitle, setMoleculaActiveTitle] = useState<string>("");

  const getMoleculaRadarData = useCallback(async () => {
    if (moleculeVActive === 1) {
      const changeStructureMoleculeData = (moleculesData?.data ?? []).find(
        (item) => item.id === idMoleculeActive
      );

      const tempData = {
        id: changeStructureMoleculeData?.documentId.toString() as string,
        idNumber: changeStructureMoleculeData?.id.toString() as string,
        product: changeStructureMoleculeData?.product as string,
        data:
          changeStructureMoleculeData?.clusters
            .map((cluster) => {
              if (cluster.cluster !== null) {
                const foundCluster = clustersData?.data.find(
                  (item) => item.id === cluster.cluster!.id
                );
                return {
                  direction_id: foundCluster?.direction.id || 83,
                  cluster_id: cluster.cluster.documentId as string,
                  technologies: cluster.technologies.map((item) => ({
                    id: item.id,
                    documentId: item.technology.documentId,
                    name: item.technology.name,
                  })),
                  strength: cluster.strength,
                  source: "0",
                };
              } else {
                return null;
              }
            })
            .filter(
              (item): item is NonNullable<typeof item> => item !== null
            ) || [],
      };

      setRadarDataMolecula(tempData);

      if (idMoleculeActive) {
        setMoleculaActiveTitle(
          moleculesData?.data.find((item) => item.id === idMoleculeActive)
            ?.product ?? ""
        );
      }

      const findMolecule = (moleculesData?.data ?? []).find(
        (item) => moleculeName === item.product
      );
      if (findMolecule) {
        setIdMoleculeActiv(findMolecule.id as number | null);
      }
    } else {
      const changeStructureMoleculeData = moleculesData2?.data.find(
        (item) => item.id === idMoleculeActive
      );

      const tempData = {
        id: changeStructureMoleculeData?.documentId.toString() as string,
        product: changeStructureMoleculeData?.productName as string,
        data:
          changeStructureMoleculeData?.products.map((cluster) => ({
            direction_id: changeStructureMoleculeData?.id || 83,
            cluster_id: cluster.id,
            name: cluster.productName,
            technologies: cluster.technologies.map((item) => ({
              id: item.id,
              documentId: item.documentId,
              name: item.name,
            })),
            strength: cluster.strength,
            source: "0",
          })) || [],
      };
      if (idMoleculeActive) {
        setMoleculaActiveTitle(
          moleculesData2?.data.find((item) => item.id === idMoleculeActive)
            ?.productName ?? ""
        );
      }
      setRadarDataMolecula(tempData);
    }
  }, [
    moleculeVActive,
    moleculesData?.data,
    idMoleculeActive,
    clustersData?.data,
    moleculeName,
    moleculesData2?.data,
  ]);

  useEffect(() => {
    if (isMoleculaRadarActive) {
      getMoleculaRadarData();
    }
    setFilters(initialStateFilters);
  }, [isMoleculaRadarActive, idMoleculeActive, getMoleculaRadarData]);

  const onCloseMoleculaRadar = () => {
    setIsMoleculaRadarActive(false);
    setIdMoleculeActiv(null);
  };

  const radarDataMemo = useMemo(
    () => getFilteredData(dataServer, filters),
    [dataServer, filters]
  );

  const [dataIds, setDataIds] = useState<DataIds>({
    directionId: null,
    clusterId: null,
    clusterIdNumber: null,
    clusterName: "",
    directionName: "",
    tehnologyName: "",
    tehnologyId: null,
  });

  useEffect(() => {
    if (activeSidebarTab === SidebarTab.Directions) {
      setActiveTab(SidebarTab.Directions);
    }
    if (activeSidebarTab === SidebarTab.Clusters) {
      setActiveTab(SidebarTab.Directions);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.CPU) {
      cpuStep === 1
        ? setActiveTab(SidebarTab.Clusters)
        : setActiveTab(SidebarTab.CPU);
      setIsOpenSideBar(true);
    }
  }, [activeSidebarTab, cpuStep]);

  const openSidebarWithTab = useCallback(
    (
      tab: SidebarTab,
      directionId: number | string,
      clusterId?: number | string,
      clusterTitle?: string,
      sectionName?: string,
      segmentColor?: {back: string; color: string},
      nameTehnology?: string,
      idTehnology?: number | string,
      typeRadar?: ITypeRadar,
      isSearchPanelActive?: boolean,
      clusterIdNumber?: number,
      idRndIndex?: number
    ) => {
      setIsVisibleFiltersPanel(false);
      setCpuStep(idTehnology ? 2 : 1);
      setActiveClusterId(clusterId);
      setActiveDirectionId(directionId);
      setActiveTehnologyId(idTehnology);
      setTypeRadar(typeRadar ?? "map");
      setDataIds({
        directionId,
        clusterId: clusterId !== undefined ? clusterId : null,
        clusterIdNumber: clusterIdNumber || null,
        clusterName: clusterTitle || "",
        directionName: sectionName || "",
        colorTitle: segmentColor?.back || "",
        tehnologyName: nameTehnology || "",
        tehnologyId: idTehnology !== undefined ? idTehnology : null,
      });
      setActiveSidebarTab(tab);
      setIsOpenSideBar(true);
      setIsOpenPanel(false);
      setIdRndIndex(idRndIndex || 0);
      if (isSearchPanelActive) {
        setIsSearchPanelActive(true);
      } else {
        setIsSearchPanelActive(false);
      }
      setIsOpenSideBarInfo(false);
      // setCpuStep(2)
    },
    []
  );

  const resetToDefaultTab = useCallback(() => {
    if (isSearchPanelActive) {
      setIsOpenPanel(true);
      setIsOpenSearchPanel(true);
    }
    setActiveTab(SidebarTab.Empty);
    setTimeout(() => {
      setActiveSidebarTab(SidebarTab.Empty);
      setCpuStep(1);
      setActiveClusterId(null);
      setActiveDirectionId(null);
      setActiveTehnologyId(null);
    }, 600);
    setIsOpenSideBar(false);
  }, [isSearchPanelActive]);

  const toggleFilter: <T>(
    filter?: string,
    value?: T,
    isReset?: boolean
  ) => void = (filter, value, isReset = false) => {
    if (isReset) {
      setFilters(initialStateFilters);
      return;
    }
    if (!filter) return;
    if (
      !FEATURE_CLUSTER_BATTERY_METRIC_ENABLED &&
      filter === "battery_russia"
    )
      return;
    if (!(filter in initialStateFilters)) return;
    setFilters((prevFilters: any) => ({
      ...prevFilters,
      [filter]: {
        value:
          typeof value === "boolean"
            ? value !== undefined
              ? value
              : !prevFilters[filter]
            : value,
        turnOn:
          value === undefined ||
          value ===
            initialStateFilters[filter as keyof typeof initialStateFilters]
              .value
            ? false
            : true,
      },
    }));
  };

  return (
    <DataIdsContext.Provider value={{dataIds, setDataIds}}>
      <DashboardContainer>
        <Suspense fallback={<FullScreenSpinner />}>
          <Sidebar
            activeTab={activeTab}
            typeRadar="map"
            setIsOpenSideBarInfo={setIsOpenSideBarInfo}
            isOpenSideBarInfo={isOpenSideBarInfo}
            searchDatasidebarInfo={searchDatasidebarInfo}
            setIsOpenPanel={setIsOpenPanel}
            isOpenPanel={isOpenPanel}
            openSidebarWithTab={openSidebarWithTab}
            onCloseCard={() => setIsOpenSideBar(false)}
            resetToDefaultTab={resetToDefaultTab}
            onFilterChange={toggleFilter}
            filters={filters}
            isVisibleFiltersPanel={isVisibleFiltersPanel}
            setIsVisibleFiltersPanel={setIsVisibleFiltersPanel}
            isShowAllLabels={isShowAllLabels}
            setIsShowAllLabels={setIsShowAllLabels}
            setIsOpenSearchPanel={setIsOpenSearchPanel}
            isOpenSideBar={isOpenSideBar}
            isNationalProjects={isNationalProjects}
            setIsNationalProjects={setIsNationalProjects}
          />

          <SidebarCardContainer isOpenSideBar={isOpenSideBar}>
            <SidebarCard
              activeTab={activeSidebarTab}
              resetToDefaultTab={resetToDefaultTab}
              setActiveTab={setActiveSidebarTab}
              cpuStep={cpuStep}
              setCpuStep={setCpuStep}
              typeRadar={typeRadar}
              idMoleculeActive={idMoleculeActive}
              moleculesData={(moleculesData?.data ?? []).find(
                (item) => item.id === idMoleculeActive
              )}
              moleculesData2={moleculesData2?.data}
            />
          </SidebarCardContainer>

          <SidebarCardContainer isOpenSideBar={isOpenSideBarInfo}>
            <SidebarInfo typeRadar="map" close={setIsOpenSideBarInfo} />
          </SidebarCardContainer>

          <TopBarContainer>
            <AboutRadarTop typeRadar={typeRadar} />
            <TechnologiesMap typeRadar={typeRadar} />
          </TopBarContainer>

          <div
            style={{
              position: "absolute",
              left: isOpenPanel ? "380px" : "95px",
              top: "15px",
              zIndex: 1,
              transition: "all 0.3s ease",
            }}
          >
            <div>
              <SearchMoleculesTopBar
                onOpenMolecule={() => setIsMoleculaRadarActive(true)}
                setIdMoleculeActiv={setIdMoleculeActiv}
                setMoleculeVActive={setMoleculeVActive}
                moleculesData={moleculesData?.data}
                moleculesData2={moleculesData2?.data}
                setTypeRadar={setTypeRadar}
              />
              <TitleMoleculeBarTopFind
                isMoleculaRadarActive={isMoleculaRadarActive}
                moleculaActiveTitle={moleculaActiveTitle}
                onCloseMoleculaRadar={onCloseMoleculaRadar}
                setTypeRadar={setTypeRadar}
              />
            </div>
          </div>
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              {isMoleculaRadarActive ? (
                <RadarChart
                  openSidebarWithTab={openSidebarWithTab}
                  radarData={radarDataMemo}
                  radarDataMolecula={radarDataMolecula}
                  activeClusterId={activeClusterId}
                  activeDirectionId={activeDirectionId}
                  typeRadar={moleculeVActive === 1 ? "molecula" : "moleculeTwo"}
                  onCloseMoleculaRadar={onCloseMoleculaRadar}
                  idMoleculeActive={idMoleculeActive}
                  activeTehnologyId={activeTehnologyId}
                  idRndIndex={idRndIndex}
                  isShowAllLabels={isShowAllLabels}
                  isOpenPanel={isOpenPanel}
                  isOpenSideBarInfo={isOpenSideBar}
                />
              ) : (
                <RadarChart
                  openSidebarWithTab={openSidebarWithTab}
                  radarData={radarDataMemo}
                  activeClusterId={activeClusterId}
                  activeDirectionId={activeDirectionId}
                  typeRadar="map"
                  isShowAllLabels={isShowAllLabels}
                  isOpenPanel={isOpenPanel}
                  isOpenSideBarInfo={isOpenSearchPanel}
                  isNationalProjects={isNationalProjects}
                />
              )}
            </>
          )}
        </Suspense>
      </DashboardContainer>
    </DataIdsContext.Provider>
  );
};

export default Dashboard;
